<template lang="pug">
  #users.custom-container
    .section-title Usuarios
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    .table-view
      .table-view-header
        .table-view-header-title
          h3 Usuarios
        .table-view-header-actions
          b-button(@click="$bvModal.show('create-modal')" size="sm" variant="secondary") + Nuevo
      list-user
    //- Modal crear usuario 
    b-modal(id="create-modal" size="lg" title="Crear Usuario" hide-footer no-close-on-backdrop)
      create-edit-form(@success="onSuccessCreate" @cancel="$bvModal.hide('create-modal')")
</template>

<script>
import ListUser from '../components/user/ListUser'
import CreateEditForm from '../components/user/CreateEditForm'

export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Usuarios',
          active:true
        },
      ]
    }
  },
  components: {
    ListUser,
    CreateEditForm
  },
  methods: {
    onSuccessCreate (msg) {
      this.$bvModal.hide('create-modal')
      this.$bvToast.toast(msg, {
        title: 'Éxito!',
        variant: 'success'
      })
    }
  }
}
</script>
